import { ArrowIcon } from 'assets/icons/ArrowIcon';
import { IconButton } from 'components/IconButton/IconButton';
import { useDeviceCategory } from 'components/Layout/useDeviceCategory';
import { type JSX, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getInvoiceNotificationSetting,
  getUserFullName,
  getUserRoleCode,
} from 'redux/User/selectors';
import { AuthenticatedUser } from 'services/authentication/useUserInformation';
import { useIntlByKey } from 'services/i18n/hooks/useIntlByKey';

import {
  USER_CARD_POPOVER_MENU_ARIA_CONTROLS,
  UserCardPopover,
} from '../UserCardPopover/UserCardPopover';
import {
  UserCardContainer,
  UserInformationContainer,
  UserNameContainer,
  UserRoleContainer,
} from './UserCard.style';

type UserCardProps = {
  user: AuthenticatedUser;
};

export const UserCard = ({ user: _user }: UserCardProps): JSX.Element => {
  const userRoleCode = useSelector(getUserRoleCode);
  const invoiceNotificationSetting = useSelector(getInvoiceNotificationSetting);
  const rolecodeIntl = useIntlByKey('roles');
  const anchorRef = useRef<HTMLDivElement>(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  // const displayedName = `${user.givenName} ${user.familyName}`;
  const displayedName = useSelector(getUserFullName);
  const { isMobileAndTablet } = useDeviceCategory();

  const handleToggle = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  return (
    <UserCardContainer
      aria-controls={isPopoverOpen ? USER_CARD_POPOVER_MENU_ARIA_CONTROLS : undefined}
      aria-haspopup="true"
      onClick={handleToggle}
    >
      <UserInformationContainer ref={anchorRef}>
        {!isMobileAndTablet && (
          <>
            <UserNameContainer>{displayedName}</UserNameContainer>
            <UserRoleContainer>{userRoleCode ? rolecodeIntl(userRoleCode) : ''}</UserRoleContainer>
          </>
        )}
      </UserInformationContainer>
      <IconButton displayStyle="grey" size="small">
        <ArrowIcon widthInPx={18} heightInPx={12} arrowDirection={isPopoverOpen ? 'top' : 'down'} />
      </IconButton>
      <UserCardPopover
        isOpen={isPopoverOpen}
        close={() => setIsPopoverOpen(false)}
        anchorRef={anchorRef}
        invoiceNotificationSetting={invoiceNotificationSetting}
      />
    </UserCardContainer>
  );
};
